<!DOCTYPE html>
<html lang="en">
<head>
    <title> Engagement Summary </title>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta http-equiv="X-Content-Type-Options" content="nosniff">
</head>
<body>
    <p-tabView class="fr-tabview__header__custom">
        <p-tabPanel>
<div class="card-pad"> 
    <div class="fr-flex__container m-t-40">
        <div class="fr-flex__col-4">
            <div class="fr-form__view">
                <label> Total No of Contracts </label>
                <span> <em> {{totalNoOfContracts ? totalNoOfContracts : "--"}} </em></span>
            </div>
            </div>
            <div class="fr-flex__col-4">
                <div class="fr-form__view">
                    <label> Total Contracted Value​ </label>
                    <span *ngIf='totalContractedValue==undefined'><em>{{totalContractedValue? totalContractedValue: "--" }}</em></span>
                    <span *ngIf='totalContractedValue!=undefined'> <em> {{ getFormattedValue(totalContractedValue, selectedCurrency) }} </em></span>
                </div>
                </div>
                <div class="fr-flex__col-4">
                    <div class="fr-form__view">
                        <label>Viewing Currency 
                            <span class="valueSelector"> <i pInputText
                                pTooltip="{{tooltipContent}}" tooltipPosition="top"
                                class="pi pi-info-circle"> </i> </span>
                        </label>                    
                        <p-dropdown appendTo="body" id="engsummaryCurrencyDropdown" [filter]="true" (onChange)="OnCurrencyChange($event)" [(ngModel)]="selectedCurrency"  [options]="currenciesData"  optionLabel="code" optionValue="code" ></p-dropdown>       
                    </div>
                    </div>
        </div>
        <div class="fr-flex__container">
            <div class="fr-flex__col-4">
                <div class="fr-form__view">
                    <label> Projected Billing </label>
                    <span *ngIf='forecastedBillingYTD==undefined'> <em>  {{ forecastedBillingYTD? forecastedBillingYTD : "--"  }} </em></span>
                    <span *ngIf='forecastedBillingYTD!=undefined'> <em>  {{ getFormattedValue(forecastedBillingYTD, selectedCurrency) }} </em></span>
                </div>
                </div>
                <div class="fr-flex__col-4">
                    <div class="fr-form__view">
                        <label> Actual Billing Till Date </label>
                        <span *ngIf='actualBillingYTD==undefined'> <em>  {{ actualBillingYTD? actualBillingYTD : "--"  }} </em></span>
                        <span *ngIf='actualBillingYTD!=undefined'> <em>  {{ getFormattedValue(actualBillingYTD, selectedCurrency) }} </em></span>
                    </div>
                    </div>
                        <div class="fr-flex__col-4">
                    <div class="fr-form__view">
                        <label> Payment Till Date </label>
                        <span *ngIf='paymentYTD==undefined'> <em>  {{ paymentYTD? paymentYTD : "--"  }} </em></span>
                        <span *ngIf='paymentYTD!=undefined'> <em>  {{ getFormattedValue(paymentYTD, selectedCurrency) }} </em></span>
                    </div>
                    </div>
            </div>
            <div class="fr-flex__container">
                    <div class="fr-flex__col-4">
                        <div class="fr-form__view">
                            <label> Outstanding Amount <i  pInputText pTooltip="Actual Billed Till Date - Payment Till Date" tooltipPosition="top" class="pi pi-info-circle"> </i>  </label>
                            <span *ngIf='outstandingAmount==undefined'> <em>  {{ outstandingAmount? outstandingAmount : "--" }} </em></span>
                            <span *ngIf='outstandingAmount!=undefined'> <em>  {{ getFormattedValue(outstandingAmount, selectedCurrency) }} </em></span>
                        </div>
                        </div>
                        <div class="fr-flex__col-4"> 
                            <div class="fr-form__view">
                                <label>Accumulative Export <i  pInputText pTooltip="For all Contracts in this Engagement" tooltipPosition="top" class="pi pi-info-circle"> </i> <button *ngIf="ExportPrivilage" (click)="showExportPopUp()" class="btn btn-outline-primary pull-right m-t--15" [disabled]="selectedAccumulativeExport==0"> <i class="pi pi-download" ></i> Export </button></label>                    
                                <p-dropdown appendTo="body" id="accumulativeExportDropdown" placeholder="Select"  [filter]="true" (onChange)="OnAccumulativeExportChange($event)" [(ngModel)]="selectedAccumulativeExport"  [options]="AccumulativeExportData"  optionLabel="Text" optionValue="Id" ></p-dropdown>
                            </div>
                        </div>
                    <div class="fr-flex__col-4"> 
                        <div class="fr-form__view">
                            <label><br></label>
                           
                             <button type="button" class="btn btn-primary btn-save" style="width:55%;margin-left:100px" (click)="addMonthlyProjections()">Projections & Draft Invoices</button>

                        </div>
                    </div>
                      
                </div>


<!-- start FinanceEngagementDashboard Code -->
<div *ngIf="viewFinanceDashboard">
    <div class="fr-flex__container m-t-10">
        
        <div class="fr-flex__col-3">
            <div class="fr-form__group">
                <label>Finance Dashboard to View</label>
                <p-dropdown appendTo="body" [options]="DashboardToViewDataSource" placeholder="Select Dashboard to View" optionLabel="label" optionValue="value"
                    (onChange)="onDashboardToViewChange($event)" [(ngModel)]="selectedDashboardToView"></p-dropdown>
            </div>
        </div>
        <div class="fr-flex__col-3">
            <div class="fr-form__group">
                <label>Fiscal Year</label>
                <p-dropdown appendTo="body" [filter]="true" [options]="fiscalYearList" optionLabel="label" optionValue="value" placeholder="Select Fiscal Year"
                [disabled]="IsDashboardTillDate || IsDashboardProductSpend " [(ngModel)]="selectedFiscalYear" (onChange)="onFiscalYearChange($event)"></p-dropdown>
                
            </div>
        </div>
        <div class="fr-flex__col-1 custom-pad-left-zero">
            <div class="fr-form__group">
                <label>&nbsp;</label>
                <button class="btn btn-primary pull-left" (click)="onDashboardApplyClick()" [disabled]="isApplyDisable"> Apply</button>
            </div>
            </div>
        </div>
    </div>

    <div class="tab-container" *ngIf="viewFinanceDashboard">
        <div>
           <div id="DashboardContainer" class="m-t-20 m-b-20"></div>
        </div>
    </div>
<!-- end FinanceEngagementDashboard Code -->
 <!-- Fiscal year code  Start -->
 <div class="fr-flex__container m-t-20">
    <div class="fr-flex__col-4">
        <h3>Fiscal Year Budget</h3>
    </div>
</div>
<div class="fr-flex__col-12 m-b-10"> 
    <p-table id="fiscalYearDataGrid" class="primeng-table-custom custom-cells__contractsummary" [resizableColumns]="true" columnResizeMode="expand" styleClass="p-datatable-striped p-datatable-gridlines" [scrollable]="true" [value]="engagementFiscalYearData" editMode="row">
        <ng-template pTemplate="header">
            <tr>                
                <th id="conSummaryFiscalYear" pSortableColumn="fiscalYear" pResizableColumn>Fiscal Year <p-sortIcon field="fiscalYear"></p-sortIcon> </th>
                <th id="conSummaryMrpBudget" pSortableColumn="budgetFY" pResizableColumn>MRP Approved Budget <p-sortIcon field="budgetFY"></p-sortIcon></th>
                <th id="conSummaryActualBilled" pSortableColumn="actualBilledFY" pResizableColumn>Actual Billed FY <p-sortIcon field="actualBilledFY"></p-sortIcon></th>
                <th id="conSummaryBudgetBalance" pSortableColumn="budgetBalanceFY" pResizableColumn>Budget Balance <p-sortIcon field="budgetBalanceFY"></p-sortIcon></th>
                
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-fiscalData> 
            <tr>
                <td>{{ fiscalData.fiscalYear}}</td>
                <td>{{(fiscalData.totalActiveContractBudget==null||fiscalData.totalActiveContractBudget=="")?'--':getFormattedValue(fiscalData.totalActiveContractBudget, selectedCurrency)}}</td>
                <td>{{(fiscalData.totalActiveContractActualBilled==null||fiscalData.totalActiveContractActualBilled=="")?'--':getFormattedValue(fiscalData.totalActiveContractActualBilled, selectedCurrency)}}</td>
                <td>{{(fiscalData.totalActiveContractBudgetBalance==null||fiscalData.totalActiveContractBudgetBalance=="")?'--':getFormattedValue(fiscalData.totalActiveContractBudgetBalance, selectedCurrency)}}</td>
              
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
            <td colspan="4" class="text-center"> No Records</td>
            </tr>
            </ng-template>
    </p-table>
</div>

<!-- Fiscal year code  End -->

                <div class="fr-flex__col-12"> 
                <div class="fr-flex__container">
                    <div class="fr-flex__col-8">
                    </div>
                    <div class="fr-flex__col-4 custom-pad-zero">
                      <button  *ngIf="ExportPrivilage"  (click)="exportexcelInvoice()" class="btn btn-outline-primary pull-right m-b-10" [disabled]="isChecked"> <i class="pi pi-download" ></i> Export </button>
                    </div>
                </div>
        </div>
                <div class="fr-flex__col-12"> 
                <p-table id="engSummaryTableName" class="primeng-table-custom finance-custom-table" [resizableColumns]="true" columnResizeMode="expand" styleClass="p-datatable-striped p-datatable-gridlines" [value]="engagementSummarydata" 
                [paginator]="true" [scrollable]="true" 
                [rows]="10" [(selection)]="checkedInvoice"
                [showCurrentPageReport]="true"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Entries"
                [rowsPerPageOptions]="[10, 20, 50, 100, 200]">
                  <ng-template pTemplate="header">
                      <tr> 
                        <th id="engSummaryTHCheckbox" class="first-child-width">
                            <p-tableHeaderCheckbox (click)="CheckboxEnabled()"></p-tableHeaderCheckbox>
                        </th> 
                          <th id="engSummaryContractID" pSortableColumn="contractID" pResizableColumn> Contract ID <p-sortIcon field="contractID"></p-sortIcon></th>
                          <th id="engSummaryTitle" pSortableColumn="title" pResizableColumn> Title <p-sortIcon field="title"></p-sortIcon></th>
                          <th id="engSummaryTotalContractValue" pSortableColumn="totalContractValue" pResizableColumn pInputText> Total Contract Value <p-sortIcon field="totalContractValue"></p-sortIcon></th>
                          <th id="engSummaryPONumber" pSortableColumn="poNumber" pResizableColumn> PO Number <p-sortIcon field="poNumber"></p-sortIcon></th>
                          <th id="engSummaryForecastedBillingTillDate" pSortableColumn="forecastedBillingYTD" pResizableColumn pInputText> Projected Billing <p-sortIcon field="forecastedBillingYTD"></p-sortIcon></th>
                          <th id="engSummaryActualBilledTillDate" pSortableColumn="actualBilledYTD" pResizableColumn pInputText> Actual Billed Till Date <p-sortIcon field="actualBilledYTD"></p-sortIcon> </th>
                          <th id="engSummaryPaymentTillDate" pSortableColumn="paymentYTD" pResizableColumn pInputText>  Payment Till Date <p-sortIcon field="paymentYTD"></p-sortIcon></th>
                          <th id="engSummaryPOUtilization" pSortableColumn="poUtilization" pResizableColumn pInputText>  PO Utilization (%) <p-sortIcon field="poUtilization"></p-sortIcon></th>
                      </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-supContracts> 
                      <tr>
                        <td id="engSummaryTDCheckbox" class="first-child-width">
                            <p-tableCheckbox [value]="supContracts" (click)="CheckboxEnabled()"></p-tableCheckbox>
                        </td>
                          <td [pTooltip]="supContracts.contractID.length > 15 ? supContracts.contractID : ''" tooltipPosition="top">{{ supContracts.contractID }}</td>
                          <td [pTooltip]="supContracts.title.length > 15 ? supContracts.title : ''" tooltipPosition="top">{{ supContracts.title }}</td>
                          <td [pTooltip]="supContracts.totalContractValue.length > 10 ? supContracts.title : ''" tooltipPosition="top">{{ getFormattedValue(supContracts.totalContractValue, selectedCurrency) }} </td>
                          <td [pTooltip]="supContracts.poNumber.length > 10 ? supContracts.poNumber : ''" tooltipPosition="top">{{ supContracts.poNumber }}</td>
                          <td [pTooltip]="supContracts.forecastedBillingYTD.length > 10 ? supContracts.forecastedBillingYTD : ''" tooltipPosition="top">{{ getFormattedValue(supContracts.forecastedBillingYTD, selectedCurrency) }} </td>
                          <td [pTooltip]="supContracts.actualBilledYTD.length > 10 ? supContracts.actualBilledYTD : ''" tooltipPosition="top">{{ getFormattedValue(supContracts.actualBilledYTD, selectedCurrency) }} </td>
                          <td [pTooltip]="supContracts.paymentYTD.length > 10 ? supContracts.paymentYTD : ''" tooltipPosition="top">{{ getFormattedValue(supContracts.paymentYTD, selectedCurrency) }} </td>
                          <td [pTooltip]="supContracts.poUtilization.length > 10 ? supContracts.poUtilization : ''" tooltipPosition="top">{{ supContracts.poUtilization }}</td>
              
              
                      </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage">
                    <tr>
                    <td colspan="9" class="text-center"> No Records</td>
                    </tr>
                    </ng-template>
              </p-table>
            </div>
           
            </div>
            </p-tabPanel>
            </p-tabView>

<!-- Monthly Projection Billing Process popup start -->
<p-dialog appendTo="body" [(visible)]="displayMonthlyProjectionDialog" [style]="{ width: '90vw' }" [modal]="true">
    <div style="display: flex; align-items: center; gap: 20px; margin-bottom: 10px;">

        <div style="display: flex; align-items: center; gap: 6px;">
            <p-radioButton name="projType" value="0" [(ngModel)]="selectedTab" inputId="monthly"
                (onClick)="onSelectionChange()"></p-radioButton>
            <label for="monthly">Projections</label>
        </div>

        <div style="display: flex; align-items: center; gap: 6px;">
            <p-radioButton name="projType" value="1" [(ngModel)]="selectedTab" inputId="draft"
                (onClick)="onSelectionChange()"></p-radioButton>
            <label for="draft">Draft Invoices</label>
        </div>

    </div>
    <div class="fr-flex__container m-t-10">

        <div class="fr-flex__col-4">
            <div class="fr-form__group">
                <label>Category <em> * </em> </label>
                <p-multiSelect appendTo="body" [options]="CategoryData" [(ngModel)]="engagementFinance.CategoryIds"
                    placeholder="Select Category" optionLabel="name" optionValue="id"
                    (ngModelChange)="onCategoryChange($event)"></p-multiSelect>
                <small class="p-error"
                    *ngIf="submitted && engMonthlyProjectionForm?.get('_categoryId')?.hasError('required')"> This field
                    is required. </small>

            </div>
        </div>
        <div class="fr-flex__col-4">
            <div class="fr-form__group">
                <label>Function <em> * </em> </label>
                <p-multiSelect appendTo="body" [options]="functionsData" [(ngModel)]="engagementFinance.FunctionIds"
                    [filter]="true" optionLabel="name" optionValue="id" placeholder="Select Function"
                    (ngModelChange)="getMRPDetails($event)"></p-multiSelect>
                <small class="p-error"
                    *ngIf="submitted && engMonthlyProjectionForm?.get('_functionId')?.hasError('required')"> This field
                    is required. </small>

            </div>
        </div>
        <div class="fr-flex__col-4">
            <div class="fr-form__group">
                <label>Contract <em> * </em> </label>
                <p-multiSelect appendTo="body" [filter]="true" [options]="contractdata"
                    [(ngModel)]="engagementFinance.Contracts" placeholder="Select Contract" optionLabel="title"
                    optionValue="id" (ngModelChange)="GetFiscalYearDataByContractId($event)"></p-multiSelect>
                <small class="p-error"
                    *ngIf="submitted && engMonthlyProjectionForm?.get('_contract')?.hasError('required')"> This field
                    is required. </small>
            </div>
        </div>
        <div class="fr-flex__col-4">
            <div class="fr-form__group">
                <label>Fiscal Year <em> * </em> </label>
                <p-dropdown [options]="fiscalYears" [(ngModel)]="engagementFinance.FiscalYears" name="fiscalYear"
                    placeholder="Select Fiscal Year" appendTo="body"
                    (onChange)="GetContractDetailsByContractId(engagementFinance.Contracts)"></p-dropdown>
                <small class="p-error"
                    *ngIf="submitted && engMonthlyProjectionForm?.get('_fiscalYear')?.hasError('required')"> This field
                    is required. </small>
            </div>
        </div>
        <div class="fr-flex__col-4">
            <div class="fr-form__group">
                <label>Month <em> * </em> </label>
                <p-multiSelect appendTo="body" [filter]="true" [(ngModel)]="engagementFinance.Months"
                    placeholder="Select Month" optionLabel="label" optionValue="value" [options]="monthDropdownData"
                    (ngModelChange)="onMonthChange()"></p-multiSelect>
                <small class="p-error"
                    *ngIf="submitted && engMonthlyProjectionForm?.get('_month')?.hasError('required')"> This field is
                    required. </small>

            </div>
        </div>
    </div>

    <p-table *ngIf="selectedTab == 0" class="primeng-table-custom custom-cells__monthlyProjection" [scrollable]="true"
        scrollHeight="400px" [value]="_contractForecastListData" [resizableColumns]="true">

        <ng-template pTemplate="header">
            <tr>
                <th pResizableColumn>Category</th>
                <th pResizableColumn>Function</th>
                <th pResizableColumn>Contract</th>
                <th pResizableColumn>Month</th>
                <th pResizableColumn>Projected Spend</th>
                <th pResizableColumn>Remarks</th>
                <th pResizableColumn>Attachments</th>
                <th pResizableColumn>Edit</th>


            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-data>
            <tr>
                <td>{{ data.category }}</td>
                <td>{{ data.function }}</td>
                <td [pTooltip]="data?.contractName && data.contractName.length > 10 ? data.contractName : ''" tooltipPosition="top">{{ data.contractName }}</td>
                <td>{{ data.forecastDate | date:'MMMM yyyy'}}</td>
                <td> <span *ngIf="data.updatedBy !=null"> {{ data.forecastedAmount }} </span> <span
                        *ngIf="data.updatedBy ==null">--</span></td>
                <td [pTooltip]="data?.remarks && data.remarks.length > 10 ? data.remarks : ''" tooltipPosition="top"> {{
                    data?.remarks && data.remarks.trim() !== '' ? data.remarks : '--' }}</td>

                <td>
                    <span
                        *ngIf="!data.financeContractForecastAttachments || data.financeContractForecastAttachments.length === 0">
                        -- </span>
                    <ng-container
                        *ngIf="data.financeContractForecastAttachments && data.financeContractForecastAttachments.length > 0">
                        <div *ngFor="let att of data.financeContractForecastAttachments" class="attachment-active">
                            <a class="table-active-link"
                                (click)="downloadFile( att.fileName || att.name, att.filePath || att.path)">
                                <span
                                    [pTooltip]="(att.name || att.fileName) ?.length > 40 ? (att.name || att.fileName)  : ''"
                                    tooltipPosition="top"><em>{{ att.name || att.fileName }}</em></span>
                                <i pInputText pTooltip="Download" tooltipPosition="top"></i>
                            </a>

                        </div>
                    </ng-container>
                </td>

                <td><button pButton type="button" icon="pi pi-pencil" class="p-button-text p-button-sm"
                        (click)="onEditRow(data)">
                    </button> </td>

            </tr>

        </ng-template>
    </p-table>


    <!-- Draft Table Start -->
    <p-table *ngIf="selectedTab == 1" class="primeng-table-custom custom-cells__monthlyProjection" [scrollable]="true"
        scrollHeight="400px" [value]="_contractAccrualListData" [resizableColumns]="true">

        <ng-template pTemplate="header">
            <tr>
                <th pResizableColumn>Category</th>
                <th pResizableColumn>Function</th>
                <th pResizableColumn>Contract</th>
                <th pResizableColumn>Month</th>
                <th>Draft Invoice Amount</th>
                <th>Status</th>
                <th pResizableColumn>Remarks</th>
                <th pResizableColumn>Attachments</th>
                <th pResizableColumn>Edit</th>


            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-data>
            <tr>
                <td>{{ data.category }}</td>
                <td>{{ data.function }}</td>
                <td [pTooltip]="data?.contractName && data.contractName.length > 10 ? data.contractName : ''" tooltipPosition="top">{{ data.contractName }}</td>
                <td>{{ data.accrualDate | date:'MMMM yyyy'}}</td>
                <td> <span *ngIf="data.updatedBy !=null"> {{ data.accrualAmount }} </span> <span
                        *ngIf="data.updatedBy ==null">--</span></td>
                <td>{{ data.accrualStatus ?? '--' }}</td>
                <td [pTooltip]="data?.remarks && data.remarks.length > 10 ? data.remarks : ''" tooltipPosition="top"> {{
                    data?.remarks && data.remarks.trim() !== '' ? data.remarks : '--' }}</td>

                <td>
                    <span
                        *ngIf="!data.financeContractAccrualAttachments || data.financeContractAccrualAttachments.length === 0">
                        -- </span>
                    <ng-container
                        *ngIf="data.financeContractAccrualAttachments && data.financeContractAccrualAttachments.length > 0">
                        <div *ngFor="let att of data.financeContractAccrualAttachments" class="attachment-active">

                            <a class="table-active-link"
                                (click)="downloadFile( att.fileName || att.name, att.filePath || att.path)">
                                <span
                                    [pTooltip]="(att.name || att.fileName) ?.length > 40 ? (att.name || att.fileName)  : ''"
                                    tooltipPosition="top"><em>{{ att.name || att.fileName }}</em></span>
                                <i pInputText pTooltip="Download" tooltipPosition="top"></i>
                            </a>
                        </div>
                    </ng-container>
                </td>
                <td><button pButton type="button" icon="pi pi-pencil" class="p-button-text p-button-sm"
                        (click)="onEditRow(data)">
                    </button> </td>

            </tr>

        </ng-template>
    </p-table>

    <!-- Draft Table End -->
    <ng-template pTemplate="footer">
        <button type="button" *ngIf="EditProjectionPrivilage" class="btn btn-primary btn-save pull-right"
            (click)="saveContractForecast()" [disabled]="!isSaveEnabled">Save</button>
        <button type="button" *ngIf="EditProjectionPrivilage" class="btn btn-secondary pull-right"
            (click)="onCancelProjection()">Cancel</button>
    </ng-template>
</p-dialog>
<!-- Monthly Projection Billing Process popup end -->

<!-- Monthly Prjection Secondary PopUp Start -->
<p-dialog appendTo="body" [(visible)]="displayMonthlyPopup" header="Edit Monthly Projection" [modal]="true"
    [style]="{width:'90vw'}" [closable]="false">
    <form [formGroup]="forecastForm">
        <div class="fr-flex__container m-t-20">
            <div class="fr-flex__col-4">
                <div class="fr-form__group">
                    <label> Month <em> * </em></label>
                    <input type="text" class="form-control read-only" pInputText
                        value="{{ forecastDetail.forecastDate | date:'MMMM yyyy' }}" readonly="readonly" />
                </div>
            </div>
            <div class="fr-flex__col-4">

                <div class="fr-form__group">
                    <label> Projected Spend <em> * </em></label>
                    <p-inputNumber formControlName="_forecastedAmount" inputId="minmaxfraction" mode="decimal"
                        [minFractionDigits]="2" class="form-control-inputNumber" type="text" [maxlength]="15"
                        [(ngModel)]="forecastDetail.forecastedAmount" />
                    <small class="p-error"
                        *ngIf="forecastSubmitted && forecastForm?.get('_forecastedAmount')?.hasError('required')">This
                        field is required.</small>
                    <small class="p-error"
                        *ngIf="forecastSubmitted && forecastForm?.get('_forecastedAmount')?.hasError('pattern')"> Only
                        numbers allowed and maximum 15 digits which includes 2 decimal places. </small>
                    <small class="p-error"
                        *ngIf="forecastSubmitted && forecastForm?.get('_forecastedAmount')?.hasError('maxlength')">
                        Maximum length is 15 characters. </small>

                </div>
            </div>

            <div class="fr-flex__col-4">
                <div class="fr-form__group">
                    <label> Attachments <i pInputText pTooltip="Maximum 3 Attachments allowed." tooltipPosition="top"
                            class="pi pi-info-circle"> </i></label>
                     <div *ngIf="selectedTab == 0">
                    <input type="file" accept=".pdf, .xls, .xlsx,.doc,.docx" multiple
                        (change)="onForecastFileChange($event)" class="form-control" formControlName="_forecastFile"
                       #forecastFileInput style="display:none;" trimSpace />
                      
                    <button type="button" (click)="forecastFileInput.click()" class="form-control" style="width: 100%;"
                        [disabled]="isUploadButtonDisabled">Upload Files</button>
                        </div>
                    <div class="display-inline-block" *ngFor="let file of uploadedFiles">
                        <a class="form-list-active" (click)="downloadAttachment(file)">
                            <span [pTooltip]="file.name.length > 40 ? file.name : ''" tooltipPosition="top"> {{
                                file.name | truncate: 40
                                }} </span>
                            <i pInputText pTooltip="Delete" tooltipPosition="top" (click)="removeForecastFile(file)"
                                class="pi pi-trash"></i>
                        </a>
                    </div>

                </div>

            </div>

        </div>
        <div class="fr-flex__container">
            <div class="fr-flex__col-12">
                <div class="fr-form__group">
                    <label> Remarks <span class="max-length"> {{forecastDetail.remarks?.length || 0}}/300 </span>
                    </label>
                    <textarea class="form-control" formControlName="_remarks" pInputTextarea
                        [(ngModel)]="forecastDetail.remarks" [maxlength]="300"></textarea>
                </div>
            </div>
        </div>
    </form>

    <ng-template pTemplate="footer">
        <button class="btn btn-primary btn-save pull-right" (click)="onSaveEditedProjection()">Save</button>
        <button class="btn btn-secondary pull-right" (click)="onCancelEdiProjction()">Cancel</button>
    </ng-template>

</p-dialog>
<!-- Monthly Prjection Secondary PopUp End -->

   <!-- Draft Invoice Secondary Popup Start -->
    <p-dialog appendTo="body" [(visible)]="displayDraftPopup" header="Edit Draft Invoice" [modal]="true"
        [style]="{width:'90vw'}" [closable]="false">
        <form [formGroup]="accrualForm">
            <div class="fr-flex__container m-t-20">
                <div class="fr-flex__col-4">
                    <div class="fr-form__group">
                        <label> Month <em> * </em></label>
                        <input type="text" class="form-control read-only" pInputText
                            value="{{ accrualDetail.accrualDate | date:'MMMM yyyy' }}" readonly="readonly" />
                    </div>
                </div>
    
                <div class="fr-flex__col-4">
    
                    <div class="fr-form__group">
                        <label> Draft Invoices Amount <em> * </em></label>
                        <p-inputNumber formControlName="_accrualAmount" inputId="minmaxfraction" mode="decimal"
                            [minFractionDigits]="2" class="form-control-inputNumber" type="text" [maxlength]="15"
                            [(ngModel)]="accrualDetail.accrualAmount"
                            [ngClass]="{'read-only-value-condication': isDisabled}" [readonly]="isDisabled" />
                        <small class="p-error"
                            *ngIf="accrualSubmitted && accrualForm?.get('_accrualAmount')?.hasError('required')">This field
                            is required.</small>
                        <small class="p-error"
                            *ngIf="accrualSubmitted && accrualForm?.get('_accrualAmount')?.hasError('pattern')"> Only
                            numbers allowed and maximum 15 digits which includes 2 decimal places. </small>
                        <small class="p-error"
                            *ngIf="accrualSubmitted && accrualForm?.get('_accrualAmount')?.hasError('maxlength')"> Maximum
                            length is 15 characters. </small>
                    </div>
                </div>
    
                <div class="fr-flex__col-4">
                    <div class="fr-form__group">
                        <label>Status <em> * </em> </label>
                        <p-dropdown appendTo="body" [filter]="true" formControlName="_statusMappingId"
                            [options]="accrualStatusDataSource" [(ngModel)]="accrualDetail.statusMappingId"
                            optionLabel="name" optionValue="id" placeholder="Select Status"
                            (onChange)="onStatusChange($event)" [ngClass]="{'read-only-dropdown':isDisabled}"
                            [readonly]="isDisabled"></p-dropdown>
                        <small class="p-error"
                            *ngIf="accrualSubmitted && accrualForm?.get('_statusMappingId')?.hasError('required')">This
                            field is required.</small>
                    </div>
                </div>
    
            </div>
            <div class="fr-flex__container">
                <div class="fr-flex__col-4">
                    <div class="fr-form__group">
                        <label> Attachments <i pInputText pTooltip="Maximum 3 Attachments allowed." tooltipPosition="top"
                                class="pi pi-info-circle"> </i></label>
                       <div *ngIf="selectedTab == 1">
                        <input type="file" accept=".pdf, .xls, .xlsx,.doc,.docx" multiple
                            (change)="onAccrualFileChange($event)" class="form-control" formControlName="_accrualFile"
                            #accrualFileInput style="display:none" trimSpace [ngClass]="{'read-only-dropdown':isDisabled}"
                            [readonly]="isDisabled" />
                          
                        <button type="button" (click)="accrualFileInput.click()" class="form-control"
                            [disabled]="isUploadButtonDisabled || isDisabled" style="width:100%">Upload Files</button>
                            </div>
                        <div class="display-inline-block" *ngFor="let file of uploadedAccrualFiles">
                            <a class="form-list-active" (click)="downloadAttachment(file)">
                                <span [pTooltip]="file.name.length > 40 ? file.name : ''" tooltipPosition="top"> {{
                                    file.name | truncate: 40
                                    }} </span>
                                <i *ngIf="!isDisabled" pInputText pTooltip="Delete" tooltipPosition="top"
                                    (click)="removeAccrualFile(file)" class="pi pi-trash"></i>
                            </a>
                        </div>
    
                    </div>
    
                </div>
    
            </div>
            <div class="fr-flex__container">
                <div class="fr-flex__col-12">
                    <div class="fr-form__group">
                        <label> Remarks <span class="max-length"> {{accrualDetail.remarks?.length || 0}}/300 </span>
                        </label>
                        <textarea class="form-control" formControlName="_remarks" pInputTextarea
                            [(ngModel)]="accrualDetail.remarks" [maxlength]="300"></textarea>
                    </div>
                </div>
            </div>
        </form>
    
    
        <ng-template pTemplate="footer">
            <button class="btn btn-primary btn-save pull-right" (click)="onSaveEditedAccruals()">Save</button>
            <button class="btn btn-secondary pull-right" (click)="onCancelEdiProjction()">Cancel</button>
        </ng-template>
    
    </p-dialog>

   <!-- Draft Invoice Secondary Popup End -->
         <!-- Export popup start -->
     <div class="card flex justify-content-center">
        <p-dialog appendTo="body" header="Export {{selectedAccumulativeExportString}}" [(visible)]="displayExportPopup" [modal]="true" [style]="{ width: '80vw' }" [draggable]="false">
            <form [formGroup]="myExportForm">
              <div class="fr-flex__container">
               <div class="fr-flex__col-4">
                <div class="fr-form__group">
                 <label> Export for <em> * </em></label>
                 <p-dropdown appendTo="body" [filter]="true" formControlName="_Exportfor"  [options]="exportForOptions" [(ngModel)]="_export.exportfor" optionLabel="name" optionValue="id" placeholder="Select"></p-dropdown>
                 <small class="p-error" *ngIf="submittedExport && myExportForm?.get('_Exportfor')?.hasError('required')">This field is required.</small>
                 </div>
 
               </div>
               <div class="fr-flex__col-4">
                <div class="fr-form__group">
                <label> Select Period <em> * </em></label>
                 <p-dropdown appendTo="body"  [filter]="true" formControlName="_Period" [(ngModel)]="_export.kpiPeriod" [options]="exportPeriod" [disabled]="disablePeriodDropdown" optionLabel="name" optionValue="id" placeholder="Select"></p-dropdown>
                 <small class="p-error" *ngIf="submittedExport && myExportForm?.get('_Period')?.hasError('required')">This field is required.</small>
               </div>
 
               </div>
               <div class="fr-flex__col-4">
               <div class="fr-form__group">
     <label> Year <em> * </em><span class="max-length"> </span></label>
   
    <input type="text" formControlName="_Year" [minlength]="4" [maxlength]="4" class="form-control fr-flex__col-2" pInputText [(ngModel)]="_export.year" placeholder="YYYY" (input)="onNumericInput($event,'_Year')" trimSpace/>
     <small class="p-error" *ngIf="submittedExport && myExportForm?.get('_Year')?.hasError('required')">This field is required.</small>
     <small class="p-error" *ngIf="submittedExport && myExportForm?.get('_Year')?.hasError('minlength')"> Min lenght is 4 characters.</small>
     </div>
     </div>
     
              </div>
            </form>
        <ng-template pTemplate="footer">
            <a type="button" class="btn btn-primary btn-save pull-right" (click)="GetEngagementAccumulativeExportData()" >Export</a>
            <a type="button" class="btn btn-secondary pull-right" (click)="cancelExportDialog()"> Cancel </a>
       </ng-template>
        </p-dialog>
     </div>
 <!-- Export popup End -->
 
</body>
</html>                
    
